import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceEmployeeListPage from "@/pages/admin/PerformanceEmployeeListPage";

export const Route = createFileRoute("/_admin/admin/performance/employees/")({
  head: () => pageHead("Admin · Performance · Employees", "AKIVA admin · performance · employees portal.", "/admin/performance/employees", true),
  component: PerformanceEmployeeListPage,
});
